/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates what should occur when entering edit mode.
 */
export var EditModeType = /*@__PURE__*/ (function (EditModeType) {
    /**
     * Edit mode is disabled.
     */
    EditModeType[EditModeType["None"] = 0] = "None";
    /**
     * Allow cells to enter edit mode and commit the value on exit.
     */
    EditModeType[EditModeType["Cell"] = 1] = "Cell";
    /**
     * Allows cells to enter edit mode but changes will be cached for later commit.
     */
    EditModeType[EditModeType["CellBatch"] = 2] = "CellBatch";
    return EditModeType;
})({});
/**
 * @hidden
 */
export var EditModeType_$type = /*@__PURE__*/ markEnum('EditModeType', 'None,0|Cell,1|CellBatch,2');
//# sourceMappingURL=EditModeType.js.map
